import c_6 from "../../assets/audio-screen/unit6/c_6.mp3"
import c_6_1 from "../../assets/audio-screen/unit6/c_6_1.mp3"


export const audio6 = [
   {
    'text':'Tony: Alo, xin chào em, hôm nay em có khỏe không?\nLê: Chào anh, em khỏe cảm ơn anh.\nTony: Tuần tới chúng ta có cuộc hộp nội bộ công ty.\nLê: Vâng ạ. Chúng ta gặp vào ngày nào tuần tới ạ?\nTony: Vào thứ 2 ngày 12 tháng 10 năm 2022.\nLê: Vâng ạ. Nhưng cuộc họp sẽ tổ chức vào lúc mấy giờ ạ?\nTony: Ah. Vào lúc 8 giờ 30 phút sáng.\nLê: Em hiểu rồi, cảm ơn anh.\nTony: Không có gì, chào em.\n',
    'audio': c_6,
  },

];

export const audio6_1 = [
    {
     'text':'Leo: Alo -Em à. Hôm nay em có khoẻ không?\nLe: Em khỏe, cảm ơn anh, thế còn anh?\nLeo: Anh khỏe cảm ơn em. Cuối này em có thời gian rảnh không?\nLe: Dạ. Vào ngày nào ạ.\nLeo: Vào tối thứ bảy.\nLe: Vâng, mấy giờ ạ?\nLeo: Sau bẩy giờ nhé? Em có thích đi xem phim cùng anh không?\nLe: Vâng ạ, em thích đi xem phim anh ạ.\nLeo: Anh sẽ đón em vào lúc 7 giờ 30 nhé?\nLe: Em cảm ơn. Nhưng em sẽ tự đi đến rạp chiếu phim ạ. Gặp anh sau nhé.\nLeo: Em đi cẩn thận, gặp em sau nha. tạm biệt em.\nLe:Tạm biệt anh.\n',
     'audio': c_6_1,
   },
 
 ];